import { trackCalculatorInit, useTrackCalculatorLoad } from '@hex/shared/tracking';
import { deepFlattenObject } from '@hex/shared/utils';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { AffordabilityFormDataType } from '../types';

export function useAffordabilityForm() {
  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors, submitCount, isDirty },
  } = useForm<AffordabilityFormDataType>({
    defaultValues: {
      secondaryApplicantExist: '0',
      primaryApplicantIncome: '',
      secondaryApplicantIncome: '',
      maritalStatus: '',
      children: 0,
      cars: 0,
      propertiesToSell: false,
      loansRemainingBalance: '',
      housingCompanyDebt: '',
      otherLoans: false,
      personalLoansBalance: '',
      creditCards: false,
      creditCardsLimit: '',
    },
  });

  const [isTracked, setIsTracked] = useState(false);
  const trackCalculatorStarted = () => {
    if (!isTracked) {
      trackCalculatorInit();
      setIsTracked(true);
    }
  };

  // focus on error functionality
  useEffect(() => {
    if (errors) {
      // errors need to be sorted according to keys in the form data type,
      // by default they are sorted in the order they were registered by RHF

      const order: Record<keyof AffordabilityFormDataType, number> = {
        secondaryApplicantExist: 0,
        primaryApplicantIncome: 0,
        secondaryApplicantIncome: 1,
        maritalStatus: 2,
        children: 3,
        cars: 4,
        propertiesToSell: 5,
        loansRemainingBalance: 6,
        housingCompanyDebt: 7,
        otherLoans: 8,
        personalLoansBalance: 9,
        creditCards: 10,
        creditCardsLimit: 11,
      };

      const flattenedErrorKeys = Object.keys(deepFlattenObject(errors))
        .filter((item) => !(item.includes('.type') || item.includes('.ref.name')))
        .map((item) => item.replace('.message', ''));

      const firstError = [...flattenedErrorKeys].sort(
        (a, b) => order[a as keyof AffordabilityFormDataType] - order[b as keyof AffordabilityFormDataType],
      )[0];

      document.getElementsByName(firstError)[0]?.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitCount]);

  useTrackCalculatorLoad('asuntolainalaskuri:tyokalut:sinulle');

  return {
    control,
    handleSubmit,
    trackCalculatorStarted,
    reset,
    watch,
    isDirty,
  };
}
